export default __webpack_public_path__ + "static/media/landingVideo1.f642425e.mp4";